import gql from 'graphql-tag';

const UPDATE_ORDER = gql`mutation updateOrder ($input: UpdateOrderInput) {
    updateOrder (input: $input) {
        message
        status
        data
    }
}`;

export default UPDATE_ORDER;
